import { render } from "./ModalVideo.vue?vue&type=template&id=c2108086&scoped=true"
import script from "./ModalVideo.vue?vue&type=script&lang=ts"
export * from "./ModalVideo.vue?vue&type=script&lang=ts"

import "./ModalVideo.vue?vue&type=style&index=0&id=c2108086&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2108086"

export default script